import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var DenyBlockSlashIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsxs("svg", {
                    viewBox: "0 0 24 24",
                    children: [
                        _jsx("path", {
                            d: "M20 19.6c1.9-2 3-4.6 3-7.6 0-6.1-4.9-11-11-11-2.9 0-5.6 1.2-7.6 3-.1 0-.2.1-.3.2-.1.1 0 .2-.1.2C2.1 6.4 1 9 1 12c0 6.1 4.9 11 11 11 2.9 0 5.6-1.2 7.6-3 .1 0 .2-.1.3-.2.1-.1 0-.2.1-.2zm1-7.6c0 2.1-.7 4.1-2 5.6L6.4 5C7.9 3.7 9.9 3 12 3c5 0 9 4 9 9zM3 12c0-2.1.7-4.1 2-5.6L17.6 19c-1.5 1.2-3.5 2-5.6 2-5 0-9-4-9-9z"
                        }),
                        _jsxs("g", {
                            fillRule: "evenodd",
                            children: [
                                _jsx("use", {}),
                                _jsx("use", {
                                    fillRule: "nonzero"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
DenyBlockSlashIcon.isCarinaIcon = true;
export default DenyBlockSlashIcon;
